<template>
    <div class="cinema-item" v-on:mouseover="mouseover" v-on:mouseleave="mouseleave">
        <div class="out-box">
            <div class="o-p-b">
                <span class="subscript-tag" v-if="cinema.is_subscript == 1"></span>
                <img width="100%" src="@/assets/images/home/opacity.png" />
                <img class="cover" width="100%" :src="cinema.imgurl ? require(`@/assets/images/home/${cinema.imgurl}.jpg`) :(cinema.thumbnail ? cinema.thumbnail : require('@/assets/images/movies/Default_cover.png'))"
                />
            </div>

            <transition name="zoom">
                <div class="c-d-b" v-show="cinemaSwitch">
                    <div style="position: relative; overflow: hidden;">
                        <img width="100%" src="@/assets/images/home/opacity.png" />
                        <img class="t-o" src="@/assets/images/home/opacf.png" />
                         <img class="t-i" width="100%"
                              :src="cinema.imgurl ? require(`@/assets/images/home/${cinema.imgurl}.jpg`) :(cinema.cover ? cinema.cover : require('@/assets/images/movies/Default_cover.png'))"
                          />
                        <div class="btn-group clearfix">
                            <img class="pull-left" src="@/assets/images/home/play.png" />
                            <!-- <img class="pull-left" @click.stop="addListsHandler(cinema.id)" src="@/assets/images/home/add_list.png" /> -->
                            <span class="pull-right" @click.stop="showDetailPanel(cinema.id)">{{ $t('home.2') }}</span>
                        </div>
                    </div>

                    <div class="d-i-b">
                        <div class="t-s-b clearfix">
                            <p class="p-title pull-left point">{{ cinema.name }}</p>
                        </div>
                        <ul class="tags point clearfix">
                            <li v-for="(item, index) in cinemaTag" :key="index">{{ item.name }}</li>
                        </ul>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "CinemaItem",
    props: {
        cinema: {
            type: Object,
            default: () => {}
        },
        index: Number
    },
    data() {
        return {
            timer: null,
            hoverEnterTime: 500,
            hoverLeaveTime: 0,
            cinemaSwitch: false,
            options: {},
            player: null,
            fetchmsp: 0
        };
    },
    computed: {
        ...mapState({
            cinemaTag: (state) => state.home.cinemaTag,
            cinemaUrl: (state) => state.home.cinemaUrl,
            swiperButton: (state) => state.home.swiperButton
        }),
    },
    methods: {
        ...mapActions({
            SetLoadStatusFn: "SetLoadStatusFn",
            SetCininfoStatusFn: "SetCininfoStatusFn",
            getAddPlayListFn: "getAddPlayListFn",
            FetchMovieSimpleFn: "FetchMovieSimpleFn",
            SetSiginStatusFn: "SetSiginStatusFn",
            SetLoadShowFn: "SetLoadShowFn",
            addLoadShowFn:"addLoadShowFn"
        }),
        mouseover () {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                if(this.index == 0 || this.index == 5){
                    if(this.swiperButton)
                        this.$store.commit("SET_SWIPER_BUTTON", false);
                }else{
                    if(!this.swiperButton)
                        this.$store.commit("SET_SWIPER_BUTTON", true);
                }
                this.cinemaSwitch = true;
                this.fetchmsp++;
                if(this.fetchmsp == 1)
                    this.FetchMovieSimpleFn({id: this.cinema.id});
            }, this.hoverEnterTime);
        },
        mouseleave () {
            this.fetchmsp = 0;
            this.$store.commit("SET_SWIPER_BUTTON", true);
            clearTimeout(this.timer)
            this.cinemaSwitch = false;
            this.$store.commit('SET_CINEMA_TAG', []);
            this.timer = setTimeout(() => {
            }, 0)
        },
        async addListsHandler(mid){

            if(window.localStorage.getItem("token")){
               this.SetLoadStatusFn({loadStatus: true});
                const result = await this.getAddPlayListFn({mid: String(mid)});
                this.SetLoadStatusFn({loadStatus: false});
            }else{
                // this.$message.warning(this.$t('account.7'));
            }
        },
        showDetailPanel(mid){
            window.localStorage.setItem("mid", mid);
            this.SetCininfoStatusFn(true)
        },
    },
    destroyed(){
        if(this.player){
            this.player.dispose();
        }
    }
}
</script>

<style scoped>

.zoom-enter-active,
.zoom-leave-active {
  transition: all .35s;
}
 .zoom-leave-to  {
  transform: scale(0.8);
  opacity: 0;
}
.zoom-enter{
  transform: scale(0.8);
}

</style>
